import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Proveedor } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

import * as SocioCrud from 'services/socio.service'

const ProveedorFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.documentoSocio = data.numeroDocumento
      values.nombreSocio = data.razonSocial

      setValues(values)
      KeyEventUtil.leaveOnKeyEvent('button-reporteCompras-submit')
    })
  }

  const clickClear = () => {
    values._idSocio = ''
    values.documentoSocio = ''
    values.nombreSocio = ''

    setValues(values)
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='PROVEEDOR' htmlFor='ro-reporteCompras-proveedor' md={3} alignRightAt='md' />
        <Col md={9}>
          {values._idSocio ? (
            <ClearInputGroup
              id='ro-reporteCompras-proveedor'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
            />
          ) : (
            <Select2Proveedor
              disabled={fIsSubmitting}
              id='select2-reporteCompras-proveedor'
              onChange={onChangeSocioHandler}
            />
          )}
          {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ProveedorFormGroup)
